import React, {useEffect, useState} from 'react';
import './WorkplacesInStaffTab.css';
import UniversalTable from '../UniversalTable/UniversalTable';
import {createPortal} from 'react-dom';
import CreateWorkplace from '../CreateWorkplace/CreateWorkplace';

import {
  dismissalUserFromWorkplace,
  removeUserFromWorkplace,
} from '../../api/staffApi';

const WorkplacesInStaffTab = ({
  dataList,
  selectedItems,
  selectedItemId,
  expandedRow,
  updateDepartmentData,
  selectedTab,
  onSelectItem,
}) => {
  const [isNotificationVisible, setIsNotificationVisible] = useState(false);

  // Состояния для CreateWorkplace
  const [isCreateWorkplaceMounted, setIsCreateWorkplaceMounted] =
    useState(false);
  const [isCreateWorkplaceVisible, setIsCreateWorkplaceVisible] =
    useState(false);
  // Состояния для InviteEmployee
  const [isPopupMounted, setIsPopupMounted] = useState(false);
  const [isVisiblePopupInvite, setIsVisiblePopupInvite] = useState(false);

  const [data, setData] = useState(dataList || []);
  const columns = [
    {key: 'department_name', title: 'Отдел'},
    {key: 'workplace_name', title: 'Рабочее место'},
    {key: 'invited_at', title: 'Дата приема'},
    {key: 'deleted_at', title: 'Дата увольнения'},
    {
      key: 'status',
      title: 'Статус',
      type: 'select',
      deleted: 'Уволен',
      awaiting: 'Ожидает подтверждения',
      button: {
        title: 'Отменить приглашение',
        onClick: (item) => {
          handleCancelInvitation(item);
        },
      },
      options: [
        {value: 'active', label: 'Активен'},
        {value: 'deleted', label: 'Уволен'},
      ],
      onChange: (options, userId) => {
        if (options.value === 'deleted') {
          handleDismissEmployee(userId);
        }
      },
    },
  ];
  const handleCancelInvitation = (item) => {
    removeUserFromWorkplace({
      users: [item.id],
      organisation_id: selectedItemId,
    })
      .then(() => {
        setData(
          (prevData) =>
            prevData
              .map((user) => {
                if (user.user_id === item.user_id) {
                  // Если сотрудник уже работал, меняем статус
                  if (user.deleted_at) {
                    return {
                      ...user,
                      status: 'deleted',
                    };
                  }
                  return null; // Помечаем для удаления
                }
                return user;
              })
              .filter(Boolean) // Убираем null (удаляем сотрудников без invited_at)
        );
      })
      .catch((err) => console.error('Ошибка при удалении пользователя:', err));
  };

  const handleDismissEmployee = (userId) => {
    dismissalUserFromWorkplace({
      users: [expandedRow],
      organisation_id: selectedItemId,
    })
      .then(() => {
        updateDepartmentData(selectedTab);
      })
      .catch((err) => console.error('Ошибка при удалении пользователя:', err));
  };

  // Обновляем data при изменении dataList
  useEffect(() => {
    setData(dataList);
  }, [dataList]);

  // Управляем плавным появлением и исчезновением
  useEffect(() => {
    if (isPopupMounted) {
      const timer = setTimeout(() => setIsVisiblePopupInvite(true), 100); // Ждем, пока попап добавится в DOM
      return () => clearTimeout(timer);
    }
  }, [isPopupMounted]);

  // После завершения анимации удаления убираем попап из DOM
  useEffect(() => {
    if (!isVisiblePopupInvite) {
      const timer = setTimeout(() => setIsPopupMounted(false), 300); // Ждем анимацию
      return () => clearTimeout(timer);
    }
  }, [isVisiblePopupInvite]);

  // Обработчик закрытия формы создания рабочего места
  const handleCloseCreateWorkplace = () => {
    setIsCreateWorkplaceVisible(false);
  };

  // Анимация появления CreateWorkplace
  useEffect(() => {
    if (isCreateWorkplaceMounted) {
      const timer = setTimeout(() => setIsCreateWorkplaceVisible(true), 100);
      return () => clearTimeout(timer);
    }
  }, [isCreateWorkplaceMounted]);

  // Анимация исчезновения и удаление из DOM CreateWorkplace
  useEffect(() => {
    if (!isCreateWorkplaceVisible) {
      const timer = setTimeout(() => setIsCreateWorkplaceMounted(false), 300);
      return () => clearTimeout(timer);
    }
  }, [isCreateWorkplaceVisible]);

  useEffect(() => {
    if (isNotificationVisible) {
      const timer = setTimeout(() => {
        setIsNotificationVisible(false);
      }, 4000);

      return () => clearTimeout(timer); // Очищаем таймер при размонтировании
    }
  }, [isNotificationVisible]);

  return (
    <div className='workplaces-tab'>
      <div className='workplaces-tab__header'>
        <h3 className='workplaces-tab__title'>Рабочие места</h3>
      </div>

      {data?.length > 0 ? (
        <UniversalTable
          data={data}
          columns={columns}
          handleContextMenu={() => {}}
          selectedItems={selectedItems}
          onRowClick={() => {}}
          onSelectItem={onSelectItem}
          expandedRow={expandedRow}
        />
      ) : (
        <p className='no-data-message'>Нет данных для отображения</p>
      )}

      {/* CreateWorkplace с анимацией */}
      {isCreateWorkplaceMounted &&
        createPortal(
          <CreateWorkplace
            selectedTab={selectedTab}
            departmentId={expandedRow}
            isEmployeeFormOpen={isCreateWorkplaceVisible}
            handleClose={handleCloseCreateWorkplace}
            selectedItemId={selectedItemId}
            updateDepartmentData={updateDepartmentData}
          />,
          document.body
        )}
    </div>
  );
};

export default WorkplacesInStaffTab;
